import Banner1 from '../../../media/banner/1.png'
import Banner2 from '../../../media/banner/2.webp'
import Banner3 from '../../../media/banner/3.png'


const bannerimages =[
    Banner1,Banner2,Banner3
]

export default bannerimages;